import React from 'react';
import { THEME } from 'GlobalStyles';
import { SvgBuilding1, SvgCandidates, SvgHiringAuthorities } from 'UI/res/icons/filled';

import FPIcon from '../FPIcon';

const { palette } = THEME;

export const avatarColors = {
  backgrounds: {
    candidate: palette.customColors.candidateBackground,
    company: palette.info.FP100,
    hiringAuthority: palette.warning.FP100
  },
  icons: {
    candidate: palette.customColors.candidateIcon,
    company: palette.info.main,
    hiringAuthority: palette.warning.main
  }
};

export const avatarDefinitions = {
  types: {
    candidate: 'candidate',
    company: 'company',
    hiringAuthority: 'hiringAuthority',
    user: 'user',
    default: 'default'
  },
  icons: {
    candidate: size => (
      <FPIcon component={SvgCandidates} size={size} color={avatarColors.icons.candidate} />
    ),
    company: size => (
      <FPIcon component={SvgBuilding1} size={size} color={avatarColors.icons.company} />
    ),
    hiringAuthority: size => (
      <FPIcon
        component={SvgHiringAuthorities}
        color={avatarColors.icons.hiringAuthority}
        size={size}
      />
    )
  }
};
